import { Moment } from 'moment/moment'

import { AppDispatch } from '../../store'
import { fetchAppointment } from '../store/thunks/fetchAppointment'
import { updateAppointmentActivity } from '../store/thunks/updateAppointmentActivity'
import { updateAppointmentTime } from '../store/utils/updateAppointmentTime'
import { IAppointment } from '../types'
import { isInstanceOfIThunkError } from '../utils/interfaceCheck'

export const handleAppointmentUpdate = (
  appointment: IAppointment,
  newDate: Moment,
  timeType: 'day' | 'hour',
  dispatch: AppDispatch,
) => {
  updateAppointmentTime(appointment, newDate, timeType).map(activity => {
    dispatch(updateAppointmentActivity(activity)).then(({ payload }) => {
      if (typeof payload !== 'undefined' && !isInstanceOfIThunkError(payload)) {
        dispatch(
          fetchAppointment({
            uuid: payload.appointmentUuid,
            type: 'update',
          }),
        )
        return null
      }
      return null
    })
  })
}
